module.exports = __webpack_public_path__ + "img/walk.e1e163b2.png";